import React, { useEffect } from "react";

import connectProps from "fantastic/lib/connectProps";
import instantInkStyles from "fantastic/lib/instantInkStyles";
import normalizeStyles from "fantastic/lib/normalizeStyles";

const Theme = ({
  theme: { asset_url, style_attributes },
  onReady = () => {},
  mobile = false
}) => {
  useEffect(() => {
    //onReady(false);
  }, [asset_url]);

  return (
    <>
      {mobile && <style>{normalizeStyles()}</style>}
      <style>{instantInkStyles(style_attributes)}</style>
      <link
        onLoad={() => onReady(true)}
        rel="stylesheet"
        type="text/css"
        href={asset_url}
      />
    </>
  );
};

export default connectProps("theme")(Theme);
